import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { DivisionForm } from '@/components/forms/DivisionForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function DivisionCreatePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/division-management/divisions')
  }

  const handleCancel = () => {
    navigate('/division-management/divisions')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Box minW={0} display="flex" flexDirection="column" overflow="hidden" flex={1}>
          <Card h="full" display="flex" flexDirection="column">
            <CardHeader flexShrink={0}>
              <Heading size="md">Create Division</Heading>
              <Text fontSize="sm" color={colors.text} mt={1}>
                Add a new division to the organization
              </Text>
            </CardHeader>
            <CardBody overflowY="auto" flex={1} minH={0}>
              <DivisionForm onSuccess={handleSuccess} onCancel={handleCancel} />
            </CardBody>
          </Card>
        </Box>
      </Box>
    </AdminLayout>
  )
}
